var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconView01 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 15 9"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  d: "M14.5 4.737S12 .625 7.5.625s-7 4.112-7 4.112"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 7.5,
  cy: 5.375,
  r: 2.5,
  stroke: "#fff"
})));
export default SvgIconView01;